import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialUserState = {
    user_name: null,
    group_id: null,
    user_tag: null,
    employee_name: null,
    email: null,
    schools: [],
};

export const UserSchema = Yup.object().shape({
    user_name: Yup.string().required(),
    group_id: Yup.number().required(),
    user_tag: Yup.string().required(),
    employee_name: Yup.string().required(),
    email: Yup.string().required().email(),
    schools: Yup.array().min(1).required(),
});

export const FormFields = [
    { name: "user_name", title: "User Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "group_id", title: "Role", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "user_tag", title: "User Tag", required: true, type: VALUE_TYPES.TEXT },
    { name: "employee_name", title: "Employee Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "email", title: "Email", required: true, type: VALUE_TYPES.TEXT },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];



const filterState = {
    schools: null,
    roles: null,
};

const filterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    roles: Yup.array().nullable(),
});

const filterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "roles", title: "Roles", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}
